import { Button } from '#components/atoms/buttons/Button.tsx';
import { Code } from '#components/atoms/code/index.ts';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import type { Host } from '#dn-types/host.ts';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  /** Decides which client the copy names; `null` when the host has never checked in. */
  platform?: Host['metadata']['platform'];
};

export function RestartHostModal({ isOpen, onClose, platform }: Props) {
  // A mobile device has no dnclient and no shell, so the desktop instructions don't apply: there
  // the change lands when the user toggles the tunnel off and back on.
  const isMobile = platform === 'mobile';

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>{isMobile ? 'Reconnect this device' : 'Restart dnclient'}</ModalHeader>
      <ModalBody>
        {isMobile ?
          <p className="p">
            You’ve changed a setting that this device applies while connecting. Disconnect and reconnect the tunnel in
            the mobile app to pick it up.
          </p>
        : <>
            <p className="p">You’ve changed a setting that requires a restart of dnclient.</p>
            <p className="p">
              Please run <Code>dnclient info</Code> on the host and confirm that your changes are applied, then restart
              dnclient.
            </p>
          </>
        }
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button variant="primary" onClick={onClose}>
              OK
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
